import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { FgiBackEndService } from "src/app/shared/fgi-back-end.service";
import { blockUi } from "@bndes/bndes-ux4/bndes-angular-utils";
import { FaixaCarteiraPessoaJuridica, ValorFaixaCarteiraPessoaJuridica } from "../../../model/faixa-carteira-pessoa-juridica.model";
import { ResultadoPaginado } from "src/app/model/resultado";

@Injectable({
    providedIn: 'root'
})
export class FaixaCarteiraPessoaJuridicaService extends FgiBackEndService<FaixaCarteiraPessoaJuridica> {

    getNewEntity(): FaixaCarteiraPessoaJuridica {
        return new FaixaCarteiraPessoaJuridica();
    }

    protected getResourceURL(): string {
        return 'front/distribuicao-limites/faixas-carteiras-pj';
    }

    public buscarFaixasCarteira(params?: any): Observable<ResultadoPaginado<FaixaCarteiraPessoaJuridica>> {
      let options: any = blockUi();
      options.params = params;
      return this.http.get(`${this.BASE_URL}/`, options).pipe
        (catchError((e) => this.handleError(e))) as Observable<ResultadoPaginado<FaixaCarteiraPessoaJuridica>>;
    }

    public buscarValoresFaixaCarteira(): Observable<Array<ValorFaixaCarteiraPessoaJuridica>> {
      const options = blockUi();
      return this.http.get(`${this.BASE_URL}/valores`, options).pipe
        (catchError((e) => this.handleError(e))) as Observable<Array<ValorFaixaCarteiraPessoaJuridica>>;
    }

    public salvarFaixaCarteira(dto: FaixaCarteiraPessoaJuridica): Observable<any> {
      const options = blockUi();
      return this.http.post(`${this.BASE_URL}/atualizar`, dto, options).pipe
        (catchError((e) => this.handleError(e))) as Observable<any>;
    }

}
